function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawMobileLife = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1077 722.2",
    style: style
  }, props), React.createElement("g", {
    opacity: 0.2
  }, React.createElement("path", {
    d: "M119.24 655.43a46.72 46.72 0 0 0-.43 7.86q26.15.42 52.5 1.75c.12-.68.24-1.38.34-2.09a41.67 41.67 0 0 0-2.45-21.73c-3.62-8.83-10.37-15.14-18.82-16.35s-16.69 2.94-22.64 10.36a41.74 41.74 0 0 0-8.5 20.2z",
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 212.98,
    cy: 706.15,
    rx: 34.66,
    ry: 26.48,
    transform: "rotate(-82 129.937 696.49)",
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 219.01,
    cy: 664.22,
    rx: 34.66,
    ry: 26.48,
    transform: "rotate(-81.82 136.98 655.267)",
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 225.03,
    cy: 622.29,
    rx: 34.66,
    ry: 26.48,
    transform: "rotate(-81.82 143.005 613.338)",
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 231.06,
    cy: 580.36,
    rx: 34.66,
    ry: 26.48,
    transform: "rotate(-81.82 149.03 571.409)",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M308.9 218.62a127.41 127.41 0 0 0 11.82-13l-67.22-21.17 74.39 11.26a127.08 127.08 0 0 0 16.69-99.12L237.21 134.1l101.88-54.49a126.83 126.83 0 1 0-227.52 110.65 127.57 127.57 0 0 0-17.61 20.84l82.71 59.28-90.71-45.68a126.9 126.9 0 0 0 3.3 120.79 126.82 126.82 0 1 0 197.33 28.35 126.83 126.83 0 0 0 22.31-155.22z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M73.55 264.02a126.32 126.32 0 0 0 15.71 81.47 126.82 126.82 0 1 0 197.33 28.35C306.5 354.9 75.58 249.93 73.55 264.02z",
    opacity: 0.1
  })), React.createElement("path", {
    d: "M0 478.5c0 98.38 61.72 178 138 178",
    fill: "#3a3768"
  }), React.createElement("path", {
    d: "M138 656.5c0-99.49 68.88-180 154-180M50 487.42c0 93.45 39.36 169.08 88 169.08",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M138 656.5c0-127.13 79.61-230 178-230",
    fill: "#3a3768"
  }), React.createElement("ellipse", {
    cx: 132.01,
    cy: 684.71,
    rx: 34.31,
    ry: 5.8,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M108.97 657.75s19.57-.6 25.47-4.8 30.1-9.21 31.56-2.48 29.42 33.5 7.32 33.68-51.34-3.44-57.23-7-7.12-19.4-7.12-19.4z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M173.72 681.81c-22.1.17-51.34-3.45-57.23-7-4.48-2.73-6.27-12.53-6.87-17h-.65s1.24 15.79 7.12 19.37 35.14 7.21 57.23 7c6.38 0 8.58-2.32 8.46-5.68-.89 2-3.28 3.27-8.06 3.31z",
    opacity: 0.2
  }), React.createElement("ellipse", {
    cx: 560.68,
    cy: 705.21,
    rx: 511,
    ry: 16.99,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("rect", {
    x: 695.36,
    y: 189.35,
    width: 9.91,
    height: 81.73,
    rx: 2.29,
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 365.79,
    y: 125.32,
    width: 5.56,
    height: 26.91,
    rx: 2.29,
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 365.59,
    y: 174.58,
    width: 6.27,
    height: 46.84,
    rx: 2.29,
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 365.69,
    y: 237.81,
    width: 5.97,
    height: 47.24,
    rx: 2.29,
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 368.94,
    y: 36.4,
    width: 331.77,
    height: 674.27,
    rx: 38.99,
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 502.82,
    y: 56.53,
    width: 46.33,
    height: 9.41,
    rx: 3.87,
    fill: "#e6e8ec"
  }), React.createElement("circle", {
    cx: 561.49,
    cy: 61.24,
    r: 5.34,
    fill: "#e6e8ec"
  }), React.createElement("path", {
    d: "M653.87 53.96h-38v4.57a21.7 21.7 0 0 1-21.7 21.7H473.11a21.69 21.69 0 0 1-21.7-21.7v-4.57h-35.63a26.35 26.35 0 0 0-26.35 26.35v586.44a26.35 26.35 0 0 0 26.35 26.35h238.09a26.34 26.34 0 0 0 26.34-26.35V80.31a26.34 26.34 0 0 0-26.34-26.35z",
    fill: "#e6e8ec"
  }), React.createElement("rect", {
    x: 457.43,
    y: 129.55,
    width: 156,
    height: 54,
    rx: 3.88,
    fill: primaryColor
  }), React.createElement("g", {
    opacity: 0.3,
    fill: primaryColor
  }, React.createElement("rect", {
    x: 435.68,
    y: 495.55,
    width: 200,
    height: 18,
    rx: 3.88
  }), React.createElement("rect", {
    x: 435.68,
    y: 523.55,
    width: 200,
    height: 18,
    rx: 3.88
  }), React.createElement("rect", {
    x: 435.68,
    y: 551.55,
    width: 200,
    height: 18,
    rx: 3.88
  }), React.createElement("rect", {
    x: 435.68,
    y: 579.55,
    width: 200,
    height: 18,
    rx: 3.88
  }), React.createElement("rect", {
    x: 435.68,
    y: 607.55,
    width: 76,
    height: 18,
    rx: 3.88
  })), React.createElement("rect", {
    x: 399.68,
    y: 236.55,
    width: 272,
    height: 206,
    rx: 5.71,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M818.4 457.88c.3 4 1.42 8.74 5.2 10.12a9.67 9.67 0 0 0 5.56-.09 23.55 23.55 0 0 0 12.34-7.07c3.14-3.66 4.72-8.83 3.39-13.46-1.26-4.42-4.83-7.72-7.34-11.57-2.93-4.49-3.87-9.57-5.91-14.39-16.14 1.55-14.14 24.44-13.24 36.46z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M801.4 265.1c-2.15 7 5.47 14.62 7.93 21.5s5.77 13.5 7.1 20.7c.91 4.95.86 10 1.22 15.05.66 9.45 2.76 18.72 5 27.91q4.75 19.92 10.17 39.67a147.78 147.78 0 0 1 4.23 18.23 70.07 70.07 0 0 1-.08 20.09 25.66 25.66 0 0 0-19.08 1.75 56.71 56.71 0 0 1-7.25-23.59 123.4 123.4 0 0 1 .14-14.77c.64-13.91-5.39-27.84-5.59-41.76a78.67 78.67 0 0 0-1.14-14.4c-.66-3.27-.6-9.39-1.31-12.65-1.13-5.18 3.73-7.57 3.46-12.88l-1.48-29c-.31-5.08-5.41-11.31-3.32-15.85z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M801.4 265.1c-2.15 7 5.47 14.62 7.93 21.5s5.77 13.5 7.1 20.7c.91 4.95.86 10 1.22 15.05.66 9.45 2.76 18.72 5 27.91q4.75 19.92 10.17 39.67a147.78 147.78 0 0 1 4.23 18.23 70.07 70.07 0 0 1-.08 20.09 25.66 25.66 0 0 0-19.08 1.75 56.71 56.71 0 0 1-7.25-23.59 123.4 123.4 0 0 1 .14-14.77c.64-13.91-5.39-27.84-5.59-41.76a78.67 78.67 0 0 0-1.14-14.4c-.66-3.27-.6-9.39-1.31-12.65-1.13-5.18 3.73-7.57 3.46-12.88l-1.48-29c-.31-5.08-5.41-11.31-3.32-15.85z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M728.38 242.63a11.1 11.1 0 0 0 2.29 4.62 256.93 256.93 0 0 0 34.44 39 18.33 18.33 0 0 0 3.23-4.55 68.85 68.85 0 0 0 8.41-34.6c-5.79-1.86-12.34-4.46-14.2-10.24-1.46-4.56.51-10-2.08-14.06-3.66-5.72-19.24-6.46-24.25-2.3-3.27 2.72-2.1 5.26-3.14 8.94-1.15 4.01-5.34 8.9-4.7 13.19z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M728.38 242.63a11.1 11.1 0 0 0 2.29 4.62 256.93 256.93 0 0 0 34.44 39 18.33 18.33 0 0 0 3.23-4.55 68.85 68.85 0 0 0 8.41-34.6c-5.79-1.86-12.34-4.46-14.2-10.24-1.46-4.56.51-10-2.08-14.06-3.66-5.72-19.24-6.46-24.25-2.3-3.27 2.72-2.1 5.26-3.14 8.94-1.15 4.01-5.34 8.9-4.7 13.19z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M733.58 704.88a13.36 13.36 0 0 0 5.48 2.3 183.6 183.6 0 0 0 58.2 4.79c2.6-.2 6.08-1.6 5.44-4.13s-4-2.22-6.3-2.93c-2.17-.66-3.8-2.41-5.41-4-6-5.95-13.27-10.54-20.42-15.08a18.66 18.66 0 0 0-5.75-2.78c-2.48-.56-5.06-.09-7.55.39-6.3 1.19-18.32 1-23.3 5.66-3.99 3.7-4.58 12.12-.39 15.78zM806.65 699.89c0 1.55.17 3.29 1.36 4.29a5 5 0 0 0 3.23.87 22.52 22.52 0 0 0 19.76-12l28-3.27c5.3-.62 10.7-1.26 15.56-3.46 5.75-2.59 10.34-7.17 14.8-11.64a5.87 5.87 0 0 0 1.72-2.48c.47-1.77-.88-3.62-2.57-4.32a10.31 10.31 0 0 0-5.41-.29c-13.67 1.88-27.39 8-40.76 4.59-3.28-.83-6.52-2.24-9.89-2a20.52 20.52 0 0 0-5.29 1.42c-4.35 1.6-17.35 3.86-20.23 7.55s-.28 16.34-.28 20.74z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M735.87 387.24c-4 6.24-12.42 7.59-18.31 12.06-9 6.87-10.59 19.67-11.1 31-.36 7.85-.57 15.8 1.17 23.46 1.21 5.34 3.35 10.41 5 15.65 3.5 11.36 4.47 23.34 5 35.23 1.38 30 .16 60.18 4 90 1.1 8.52 2.62 17 3.45 25.55 2.76 28.32-1.91 57.52 5.67 84.94a44.14 44.14 0 0 1 31.75-14.22c2.51 0 5.12.15 7.42-.86s4.11-3.69 3.16-6a19.05 19.05 0 0 0-2-2.83c-3.3-5 2.32-12.08-.09-17.59-.92-2.11-2.94-3.68-3.52-5.92-.63-2.42.59-4.9.93-7.38.67-5-2.2-9.65-3.69-14.45-2.25-7.25-1.35-15-.57-22.59a641.93 641.93 0 0 0 3.4-74.66c-.22-16.87-1.06-34.1 3.8-50.26a127.91 127.91 0 0 1 23.12 29.26c3.88 6.62 7.23 13.68 8.52 21.24 1 5.54.76 11.21.57 16.84l-2.88 86.3c-.59 17.39-1.09 35.3 4.95 51.63 15.32-8.17 31-16 46.33-24.21-.26-5.66-7.85-7.72-10.66-12.64a15.71 15.71 0 0 1-1.59-6.59c-1.95-23.38 2.83-46.74 7.24-69.78 1.68-8.78 3.31-17.62 3.31-26.56 0-14.18-4.16-28-8.44-41.5-4.54-14.32-9.29-28.57-14-42.82-3.05-9.15-6.1-18.31-9.91-27.17-3.61-8.37-7.89-16.47-11-25.05-4.93-13.78-6.61-28.47-8.27-43-20.84 4.15-41.98 8.78-62.76 12.92z",
    fill: "#3a3768"
  }), React.createElement("circle", {
    cx: 746.35,
    cy: 203.73,
    r: 29.22,
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M757.27 274.37l-2.12-15.84a12.79 12.79 0 0 0-1.4-5.06 13 13 0 0 0-3.66-3.5l-20.36-14.87c-1-.76-2.38-1.56-3.53-1a3.36 3.36 0 0 0-1.42 2.07c-3.21 9.51-1.23 19.86-.1 29.83.94 8.31 1.26 16.68 1.58 25a186.54 186.54 0 0 1 0 22.68c-1.11 13.08-5 26.25-2.39 39.11 1.71 8.51 4.75 16.42 5.46 25.08.48 6 .33 12.1 2.23 17.79 7-3 14.92-2.68 22.54-2.27l18.46 1a33.58 33.58 0 0 0 7.7-.18 25.85 25.85 0 0 0 8.06-3.16 55.29 55.29 0 0 0 16.86-14.7c-3.12-15.07-.1-30.63-2.17-45.88-1.2-8.79-4.17-17.25-5.57-26-1.73-10.8-1-22-4.15-32.49a93.54 93.54 0 0 0-6.63-15.37 28.44 28.44 0 0 0-12.72-12.95 6.9 6.9 0 0 0-3.33-.85c-2.95.16-4.77 3.28-5.58 6.12-1 3.41-1.29 7-2.06 10.41-1.18 5.02-2.8 10.82-5.7 15.03z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M697.38 462.88c3.9 4.11 11 3.1 15.52-.29 9.85-7.36 10.76-21.47 11.3-33.75.19-4.41.49-9 2.56-12.86 3.17-6 9.71-9.1 15.15-13.08 12.9-9.45 20.48-25 22.74-40.79s-.33-32-4.69-47.37c-7.54-26.57-20.24-51.34-33.13-75.76a5.52 5.52 0 0 0-1.8-2.29c-2.62-1.63-5.46 1.58-7.25 4.09-6.07 8.51-16.07 13.06-25.23 18.09s-18.53 11.73-21.3 21.8c-1.86 6.76-.41 13.93 1 20.78s6.34 12.29 10.07 18.06A176.31 176.31 0 0 1 694 339.4a37.53 37.53 0 0 1 3 8.07 48.16 48.16 0 0 1 .79 10c.22 20.72.43 41.51-2.08 62.09-1.41 11.63-3.69 23.31-2.65 35 .28 3.17 2.11 5.97 4.32 8.32z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M722.08 424.25c4.17 1.87 8.37 3.79 12.88 4.53s9.42.14 13-2.64 5.45-8.08 3.41-12.16a61.62 61.62 0 0 0 9.6-.45c1.82-.24 4-.94 4.32-2.75.33-2.13-2.24-3.4-4.31-4l-11.15-3.08a40.17 40.17 0 0 0-10.08-1.86 40.65 40.65 0 0 0-6.33.63l-16.92 2.63a3.1 3.1 0 0 0-1.28.4 3 3 0 0 0-1 1.68c-.82 2.6-4.61 9.84-3.31 12.41 1.07 2.17 8.84 3.51 11.17 4.66z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M828.64 435.21a17.29 17.29 0 0 1-10.86 9.51 5.94 5.94 0 0 1-3.23.21c-2-.55-3.1-2.64-3.93-4.54-19.81-45.09-18.7-96.4-31.29-144-3.74-14.13-8.74-28.33-7.84-42.92.16-2.61.71-5.54 2.89-7 1.94-1.3 4.58-.95 6.71 0s3.95 2.5 6 3.56c3.31 1.69 7.16 2.17 10.34 4.08 4.72 2.84 7.13 8.24 9.24 13.32 4.51 10.85 9 22 9.36 33.76.76 22.84-9.37 44.79-4.09 67a133 133 0 0 0 4.08 12.94 393.45 393.45 0 0 1 13 46.81c.59 2.71.72 4.78-.38 7.27z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M727.4 206.3c1.74-2.84 4.17-5.33 5.12-8.52.67-2.26.53-4.73 1.33-6.95 2-5.48 8.95-7.5 14.69-6.55s10.93 4 16.54 5.53c3.11.85 7.44.59 8.32-2.51.58-2.06-.82-4.11-2.14-5.8l-16.56-21.21c-2.19.56-4.62 1.09-6.6 0-1.15-.62-2-1.74-3.28-2.09-3.45-1-6.34 4.31-9.8 3.38-1-.26-1.79-1-2.79-1.08-2.79-.23-3.84 4.39-6.63 4.62-1.16.1-2.27-.64-3.43-.53a4.39 4.39 0 0 0-2.59 1.61c-5.54 5.89-7.8 14.34-7.5 22.43s-1.09 15.91 2 23.38c1.37 3.25 4.12 7.09 7.48 6 0-4.4 4.1-8.79 4.15-13.18",
    fill: "#3a3768"
  }), React.createElement("path", {
    d: "M783.86 502.1a127 127 0 0 0-21.58-26.72c-4.86 16.16-4 33.39-3.8 50.26a641.93 641.93 0 0 1-3.4 74.66c-.78 7.55-1.68 15.34.57 22.59 1.49 4.8 4.36 9.47 3.69 14.45-.34 2.48-1.56 5-.93 7.38.58 2.24 2.6 3.81 3.52 5.92 2.41 5.51-3.21 12.56.09 17.59a19.05 19.05 0 0 1 2 2.83c1 2.32-.86 5-3.16 6s-4.91.84-7.42.86a44.21 44.21 0 0 0-26.14 9.11 118 118 0 0 0 3.41 18.1 44.14 44.14 0 0 1 31.79-14.22c2.51 0 5.12.15 7.42-.86s4.11-3.69 3.16-6a19.05 19.05 0 0 0-2-2.83c-3.3-5 2.32-12.08-.09-17.59-.92-2.11-2.94-3.68-3.52-5.92-.63-2.42.59-4.9.93-7.38.67-5-2.2-9.65-3.69-14.45-2.25-7.25-1.35-15-.57-22.59a641.93 641.93 0 0 0 3.4-74.66c-.22-16.87-1.06-34.1 3.8-50.26a123.54 123.54 0 0 1 12.52 13.73z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M712.1 189.57v-4.14c-.05 1.07-.06 2.14 0 3.21-.01.31 0 .62 0 .93zM765.08 185.81c-5.61-1.54-10.79-4.59-16.54-5.53s-12.71 1.07-14.69 6.55c-.8 2.22-.66 4.69-1.33 6.95-.95 3.19-3.38 5.68-5.12 8.52l-1.65-1.46c0 4.39-4.1 8.78-4.15 13.18-3.36 1.09-6.11-2.75-7.48-6a30.23 30.23 0 0 1-2.07-11.26c-.09 5.23 0 10.33 2.07 15.26 1.37 3.26 4.12 7.1 7.48 6 0-4.4 4.1-8.79 4.15-13.18l1.65 1.46c1.74-2.84 4.17-5.33 5.12-8.52.67-2.26.53-4.73 1.33-6.95 2-5.48 8.95-7.5 14.69-6.55s10.93 4 16.54 5.53c3.11.85 7.44.59 8.32-2.51a4.42 4.42 0 0 0-.4-3.12c-1.39 2.26-5.13 2.39-7.92 1.63z"
  })), React.createElement("path", {
    d: "M670.57 310.46a147.79 147.79 0 0 1-3.68 18.13l-7 28.53c-.75 3-1.51 6.16-1.17 9.27.46 4.19 2.84 7.9 5.25 11.36a226.63 226.63 0 0 0 49.53 51.44c-1.11-5.69 2.84-11 6.56-15.48s7.32-8.77 12.17-11.67q-18.18-17.15-35.22-35.45a18.51 18.51 0 0 1-3.06-3.95c-2.74-5.29 0-11.61 2.39-17.08 7.53-17.39 11.08-37.12 6.25-55.45-1.82-6.88-5-13.77-10.79-18-2.53-1.84-5.95-3.1-8.76-1.7a9.73 9.73 0 0 0-3 2.69c-8.97 10.91-7.9 24.06-9.47 37.36z",
    fill: "#3f3d56"
  }), React.createElement("g", {
    opacity: 0.2
  }, React.createElement("path", {
    d: "M961.61 632.35a43.19 43.19 0 0 0 1.75 6.65q21.33-6.87 43.07-13c-.09-.6-.17-1.22-.28-1.84a36.71 36.71 0 0 0-7.79-17.36c-5.29-6.33-12.45-9.71-19.63-8.38s-12.76 7-15.61 14.84a37.43 37.43 0 0 0-1.51 19.09z",
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 1039.09,
    cy: 680.67,
    rx: 22.64,
    ry: 30.29,
    transform: "rotate(-8.99 442.48 1027.092)",
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 1032.8,
    cy: 644.2,
    rx: 22.64,
    ry: 30.29,
    transform: "rotate(-8.99 436.19 990.697)",
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 1026.5,
    cy: 607.72,
    rx: 22.64,
    ry: 30.29,
    transform: "rotate(-8.99 429.905 954.237)",
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 1020.2,
    cy: 571.25,
    rx: 22.64,
    ry: 30.29,
    transform: "rotate(-8.99 423.62 917.778)",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M998.97 217.41a112.41 112.41 0 0 0 6.14-14l-60.21.94 63.36-11.17a113.06 113.06 0 0 0 1.88-47.46 111.77 111.77 0 0 0-14.78-39.43L918.25 167l68.12-73.33c-24.08-29.18-62.3-44.76-101.74-37.5-58.9 10.85-98.22 68.53-87.81 128.83a110.78 110.78 0 0 0 34.48 63.31 113.37 113.37 0 0 0-8.72 22.15l82.92 26.38-85.79-12.91a113.5 113.5 0 0 0 .42 36.06 110.78 110.78 0 0 0 34.48 63.31 112.94 112.94 0 0 0-11.17 71.71c10.41 60.31 66.6 100.4 125.51 89.56s98.22-68.53 87.81-128.83a110.78 110.78 0 0 0-34.48-63.31 112.94 112.94 0 0 0 11.22-71.71 110.69 110.69 0 0 0-34.53-63.31z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M820.13 319.99a110.78 110.78 0 0 0 34.48 63.31 112.94 112.94 0 0 0-11.17 71.71c10.41 60.31 66.6 100.4 125.51 89.56s98.22-68.53 87.81-128.83a110.78 110.78 0 0 0-34.48-63.31c11.09-21.21-204.26-44.69-202.15-32.44z",
    opacity: 0.1
  })), React.createElement("path", {
    d: "M909 549c0 52.31 32.81 94.64 73.37 94.64",
    fill: "#3a3768"
  }), React.createElement("path", {
    d: "M982.37 643.64c0-52.9 36.62-95.7 81.87-95.7M935.58 553.75c0 49.68 20.93 89.89 46.79 89.89",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M982.37 643.64c0-67.59 42.32-122.28 94.63-122.28",
    fill: "#3a3768"
  }), React.createElement("ellipse", {
    cx: 973.89,
    cy: 653.9,
    rx: 18.68,
    ry: 3.16,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M961.35 639.23s10.65-.33 13.86-2.62 16.39-5 17.19-1.35 16 18.24 4 18.34-28-1.88-31.15-3.83-3.9-10.54-3.9-10.54z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M996.59 652.32c-12 .1-27.94-1.87-31.15-3.83-2.44-1.48-3.41-6.82-3.74-9.28h-.35s.67 8.59 3.88 10.54 19.12 3.92 31.15 3.83c3.47 0 4.67-1.27 4.6-3.1-.48 1.13-1.8 1.82-4.39 1.84z",
    opacity: 0.2
  }));
};

UndrawMobileLife.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawMobileLife;